type SectionHeadingProps = {
  badge: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkHref?: string;
};

export default function SectionHeading({ badge, title, desc, linkText, linkHref }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="flex items-start gap-4">
        <span className="mt-1 hidden h-10 w-1.5 rounded-full bg-accent-500 sm:block" />
        <div>
          <span className="font-label text-xs font-bold uppercase tracking-[0.25em] text-accent-600">{badge}</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
          {desc ? <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">{desc}</p> : null}
        </div>
      </div>
      {linkText && linkHref ? (
        <a
          href={linkHref}
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {linkText}
          <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line"></i>
          </span>
        </a>
      ) : null}
    </div>
  );
}